import React, {useState, useEffect, useMemo} from 'react';
import {ContentHeader, Button, Input} from '@components';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import DataTable from 'react-data-table-component';
import {useDispatch, useSelector} from 'react-redux';
import {setLoading} from '@app/store/reducers/ui';
import {Modal} from 'react-bootstrap';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import Api from '../../utils/axios';

import {
    customStyles,
    paginationComponentOptions
} from '../../utils/table-config';

const headerButtons = [
    {
        text: 'Agregar nueva categoria',
        urlSlug: '/categories/create'
    }
];

const Categories = () => {
    const [t] = useTranslation();
    const api = new Api();
    const [open, setOpen] = useState(false);
    const [categories, setCategories] = useState([]);
    const history = useHistory();
    const loading = useSelector((state) => state.ui.loading);
    const dispatch = useDispatch();
    const columns = useMemo(() => [
        {
            name: '',
            cell: (row) => (
                <>
                    <Button
                        className="mr-1 btn btn-danger"
                        onClick={() => handleButtonClick(row)}
                        id={row.id}
                    >
                        <i className="icon-button fa fa-trash" />
                    </Button>
                    <Button
                        className="mr-1 btn btn-danger"
                        onClick={() => handleRedirect(row?.id)}
                        id={row.id}
                    >
                        <i className="icon-button fa fa-edit" />
                    </Button>
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true
        },
        {
            name: <b>{t('categories.label.name')}</b>,
            selector: (row) => row.name,
            sortable: false,
            style: {
                '&:hover': {
                    minWidth: 'min-content',
                    fontWeight: '600'
                }
            }
        }
        // {
        //     name: <b>{ t('general.label.points')}</b>,
        //     selector: row => row.value,
        //     sortable: true,
        // },
        // {
        //     name: <b>{t('categories.label.existence')}</b>,
        //     selector: row => row.stock,
        //     sortable: true,
        // },
        // {
        //     name: <b>{t('categories.label.category')}</b>,
        //     selector: row => row.category.name,
        //     sortable: true,
        // },
        // {
        //     name: <b>{t('categories.label.subcategory')}</b>,
        //     selector: row => row.subCategory ? row.subCategory.name : '',
        //     sortable: true,
        // },
        // {
        //     name: '',
        //     cell: (row) => <Button className="mr-1 btn btn-danger" onClick={() => handleButtonClick(row)} id={row.id} ><i className="icon-button fa fa-edit"></i></Button>,
        //     ignoreRowClick: true,
        //     allowOverflow: true,
        //     button: true,
        // }
    ]);

    // Paginations Reset
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    useEffect(() => {
        dispatch(setLoading(true));
        api.getCategories()
            .then((response) => {
                console.log('response', response?.data);
                setCategories(response?.data);
                dispatch(setLoading(false));
            })
            .catch((error) => {
                dispatch(setLoading(false));
            });
    }, []);

    const handleButtonClick = (item) => {
        dispatch(setLoading(true));
        api.delCategory(item?.id)
            .then(() => {
                api.getCategories()
                    .then((response) => {
                        setCategories(response?.data);
                        dispatch(setLoading(false));
                    })
                    .catch(() => {
                        dispatch(setLoading(false));
                    });
            })
            .catch(() => {
                dispatch(setLoading(false));
            });
    };

    const handleRedirect = (id) => {
        history.push(`/categories/edit/${id}`);
    };

    const formikCreate = useFormik({
        initialValues: {
            name: ''
        },
        validationSchema: Yup.object({
            name: Yup.string().required(t('Campo requerido.'))
        }),
        onSubmit: (values) => {
            dispatch(setLoading(true));
            api.postCategories({
                Name: values?.name,
                Status: 1
            })
                .then(() => {
                    api.getCategories()
                        .then((response) => {
                            setCategories(response?.data);
                            dispatch(setLoading(false));
                            setOpen(false);
                        })
                        .catch(() => {
                            dispatch(setLoading(false));
                        });
                })
                .catch(() => {
                    dispatch(setLoading(false));
                });
        }
    });

    return (
        <div id="news-list">
            <div>
                <Modal centered show={open} onHide={() => setOpen(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title className="text-danger font-weight-bold">
                            Nueva categoria
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form
                            className="form-horizontal"
                            onSubmit={formikCreate.handleSubmit}
                        >
                            <div className="form-row mt-3 d-flex align-items-center">
                                <div className="form-group col-md-6">
                                    <Input
                                        formik={formikCreate}
                                        formikFieldProps={formikCreate.getFieldProps(
                                            'name'
                                        )}
                                        type="text"
                                        value={formikCreate?.values?.name}
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <Button
                                        // isLoading={points}
                                        type="submit"
                                        block
                                        className="btn btn-danger"
                                    >
                                        Guardar
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className="btn btn-danger"
                            onClick={() => setOpen(false)}
                        >
                            {t('general.buttons.cancel')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>

            <div className="col-sm-12 d-flex justify-content-between align-items-center">
                <ContentHeader title={t('menusidebar.label.categories')} />
                <Button
                    type="button"
                    onClick={() => {
                        setOpen(true);
                    }}
                    className="btn btn-danger ml-2"
                >
                    <i className="icon-button fa fa-plus mr-2" />
                    Nueva categoria
                </Button>
            </div>
            {categories && categories.length > 0 ? (
                <DataTable
                    data={categories}
                    customStyles={customStyles}
                    progressPending={loading}
                    paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                    subHeader
                    // subHeaderComponent={subHeaderComponentMemo}
                    noDataComponent="No se encuentran registros"
                    pagination
                    paginationComponentOptions={paginationComponentOptions}
                    highlightOnHover
                    columns={columns}
                />
            ) : (
                <div>
                    <h1 className="text-center">
                        {t('general.label.noRegisters')}
                    </h1>
                </div>
            )}
        </div>
    );
};

export default Categories;
